var map = {
	"./avanti/logo.avif": 1020,
	"./canon/logo.avif": 5819,
	"./deermates/logo.avif": 1152,
	"./eximbanka/logo.avif": 661,
	"./grandhotel-brno/logo.avif": 3891,
	"./skoda/logo.avif": 9664,
	"./stavebne-konania/logo.avif": 7799,
	"./sunsense/logo.avif": 922,
	"./websupport/logo.avif": 4414,
	"./zihadielko/logo.avif": 4624
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8277;